import React from 'react';
import './stepUI.scss';
import Animal from 'components/Animal/Animal';
import { useTranslation } from 'react-i18next';
const StepUI = ({
    step,
    index,
    CurrentSelectedStep,
    setCurrentSelectedStep,
    handleOpenStepper,
    calcStepState,
    isCelebrate = false,
    IsStepCelebrationStepCompleteClass = false,
    coinName = null,
    ImageToShow = null,
    teaserThumbnail = null

}) => {

    const { t } = useTranslation();
    const handleClickOnStep = (stepIndex) => {
        if(CurrentSelectedStep === stepIndex) {
            if(calcStepState(stepIndex) === "enabled") {
                handleOpenStepper();
            }
        } else {
            setCurrentSelectedStep(stepIndex);
        }
    }
    
    return (
        <div key={index}
        className={[ "stepUI",  
            isCelebrate
            ? [
                "stepUI-celebrate stepUI-selected enterScaleDown ",
                IsStepCelebrationStepCompleteClass && "stepUI-celebrate-completed jello-vertical ",
                ]
            : [
                CurrentSelectedStep === index && "stepUI-selected",
                calcStepState(index) === "enabled" && "stepUI-enabled",
                calcStepState(index) === "disabled" && "stepUI-disabled",
                calcStepState(index) === "completed" && "stepUI-completed",
                ],
            ].flat().filter(Boolean).join(" ")
        }
        onClick={() => handleClickOnStep(index)}
        >
        {/* {isCelebrate &&<div className={"stepUI-top"}>
             <img className="stepUI-teaserThumbnail" src={teaserThumbnail} alt="teaser thumbnail" />
        </div>} */}
        <div className={"stepUI-bottom "}>

            <div className="stepUI-start">

                {/* // Step type icon*/}
                {step.StepNumberToShow && <div className="stepUI-number">{step.StepNumberToShow}</div>}
                {step.AnimalName && (
                <div className="stepUI-animal">
                    <Animal id={step.AnimalName} alt="my animal" />
                </div>
                )}
                {step.coinName && (
                <div className="stepUI-coin">
                    <img className={"stepUI-coin-img" } src={"/assets/coins/coin_" + step.coinName + "_on.svg"} alt={step.coinName} />  
                </div>
                )}
                {step.ImageToShow && (
                    <div className="stepUI-imageToShow">
                        <img src={step.ImageToShow} alt={step.name} />
                    </div>
                )}
                <div className="lessonStepUI-name">{t(step.name)}</div>
            </div>
            <div className="stepUI-end">
                
                {(calcStepState(index) === "completed") ? 
                        !isCelebrate && <img className="stepUI-green-v" src="/assets/icons/icon_green_v_completed.svg" alt="icon V" />
                        :
                        !isCelebrate && calcStepState(index) !== "enabled" && <div className="stepUI-green-v-placeholder"></div>
                }
                {IsStepCelebrationStepCompleteClass ? 
                        <img className="stepUI-green-v " src="/assets/icons/icon_green_v_completed.svg" alt="icon V" />
                        :
                        isCelebrate && <div className="stepUI-green-v-placeholder"></div>
                }
                {/* { calcStepState(index) === "enabled" && 
                    <div className="enabled-circle breathCurrentOutlineNoOffset"></div>
                } */}
                { calcStepState(index) === "enabled" && <div className="stepUI-chevron breathCurrentOutlineNoOffset">
                    <img  src="/assets/icons/icon_chevron.svg" alt="chevron icon" />
                </div>}
            </div>
        </div>
    </div> 
    )
}

export default StepUI;

